Greenmile.Panel = Greenmile.Panel || {};

Greenmile.Panel.Updater = function (id) {
    this.panelId = id;
    this.pid = null;
    this.continue = true;
    this.updateInterval = (Monet.Session.Configurations.timeToUpdate || 60) * 1000;
    this.tabSelector = null;
    this.updateIntervalChanged = false;
    this.lastUpdateRequestHasFinished = true;

    this.setUpdateInterval = (milliseconds) => {
        this.updateInterval = milliseconds;
    }

    this.run = function () {
        if (this.continue) {
            this.pid = setTimeout(() => {
                this.lastUpdateRequestHasFinished && this.update();
            }, this.updateInterval);
        } else {
            console.log("Updater has been stopped");
        }
    };

    this.start = function () {
        this.continue = true;
        this.run();
    };

    this.stop = function () {
        this.continue = false;
        clearTimeout(this.pid);
    };

    this.firstResult = function (id) {
        var panel = App.Panels[id],
            tab = panel.getTab(),
            cardContainer = tab.querySelector(".CardContainer");

        var line = Math.floor(cardContainer.scrollTop / panel.cardSize.height),
            width = panel.cardsPerPage.width,
            first = Math.floor(line * width) - width;

        if (first < 0) {
            first = 0;
        }

        return first;
    };

    this.update = () => {
        const id = this.panelId;
        const panel = App.Panels[id];

        if (!panel) {
            console.log("[PANEL] panel with id(" + id + ") does not exists");
            this.run();
            return;
        }

        const tab = panel.getTab();
        let cardContainer = null;

        if (tab) {
            cardContainer = tab.querySelector(".CardContainer");
        }

        if (id && cardContainer) {
            var data = panel.header.getFilterWithPagination();
            data.firstResult = this.firstResult(id);
            this.lastUpdateRequestHasFinished = false;
            Greenmile.Panel.Resources.getCardsByMonetCriteria({
                id: id,
                data: data,
                onSuccess: function (response) {
                    this.lastUpdateRequestHasFinished = true;
                    const pendingCards = response.pendingCards;
                    if (!this.updateIntervalChanged && pendingCards === 0) {
                        this.updateInterval = (Monet.Session.Configurations.timeToUpdate || 60) * 1000;
                        this.updateIntervalChanged = true;
                    }

                    panel.cardList.setTotals(response);
                    panel.cardList.updateTotals();
                    panel.cardList.updateCards(response.panelCards);

                    this.run();
                }.bind(this),
                onError: function () {
                    this.lastUpdateRequestHasFinished = true;
                    this.run();
                }.bind(this)
            });
        } else {
            this.run();
        }
    };
};
